import { useMutation, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ITutor } from '../../../../model/tutor.interface'
import apis from '../../../apis'
import { getJwtToken } from '../../../auth'
import { axiosPost } from '../../../axiosHelper'
import QueryApi from '../../../react-query/queryApiClass'
import { ITutorProfileResponse } from './types'

export interface ITutorSearchQueryPayload {
  search?: string
  gender: number[]
  accent: number[]
  field_of_study: number[]
  strength: number[]
  experience_work: boolean
  experience_graduate: boolean
  is_featured: boolean
  is_pointback: boolean
  page: number
  size: number
  coupon_type_id?: number
  classtime_id?: number
}
interface ISearchResponse {
  success: boolean
  count: number
  result: ITutor[]
}

export const useSearchTutors = () => {
  const token = getJwtToken()
  return useMutation<ISearchResponse, AxiosError, ITutorSearchQueryPayload>({
    mutationFn: (payload) => {
      return axiosPost(apis.tutor.searchTutor(), payload)
    },
  })
}
export const useTutors = () => {
  return useMutation<ISearchResponse, AxiosError, ITutorSearchQueryPayload>({
    mutationFn: (payload) => {
      return axiosPost(apis.lessonBook.tutors(), payload)
    },
  })
}
export const useTutorsForBooking = (payload) => {
  return useQuery<ISearchResponse, AxiosError>({
    queryKey: ['tutors', payload],
    queryFn: () => {
      return axiosPost(apis.lessonBook.tutors(), payload)
    },
    // onError: (error) => handleAxiosError(error),
  })
}

interface ITutorProfileQueryApiSearchParams {
  tutor_id: number
  locale: string
}

export const tutorProfileQueryApi = new QueryApi<void, ITutorProfileQueryApiSearchParams>({
  api: apis.tutor.detail,
})

export const useTutorProfile = ({ tutor_id, locale }) => {
  const token = getJwtToken()
  const searchParams = { tutor_id, locale }
  return useQuery<ITutorProfileResponse, AxiosError, ITutor>({
    queryKey: tutorProfileQueryApi.getQueryKey({ searchParams }),
    queryFn: tutorProfileQueryApi.getQueryFn({ searchParams }),
    // onError: (error) => handleAxiosError(error),
    select: (data) => data.tutor,
    enabled: !!token && !!tutor_id,
  })
}
